export default __webpack_public_path__ + "static/media/gaveta-dinheiro.91425d3b.png";